import { render, staticRenderFns } from "./RandomSocial.vue?vue&type=template&id=0be59a5d&scoped=true&"
import script from "./RandomSocial.vue?vue&type=script&lang=js&"
export * from "./RandomSocial.vue?vue&type=script&lang=js&"
import style0 from "./RandomSocial.vue?vue&type=style&index=0&id=0be59a5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be59a5d",
  null
  
)

export default component.exports